import SearchInput from "_components/SearchInput";
import { CustomTable } from "_components/table/CustomTable";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export { DatasTableFleetBuses }

function DatasTableFleetBuses ({fleet, height}) {

    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    const handleViewBus = (item) => {
        navigate(`/donnees/bus/${item.VIN}`)
    }

    useEffect(() => {
        if(fleet) {
            const results = fleet.map((item, index) => ({
                PARK_NUMBER: item.PARK_NUMBER ?? '',
                VIN: item.VIN ?? '',
                STATE: item.STATE === 'EN  ATTENTE' ? 'EN EXPLOITATION' : (item.STATE ?? 'OFFLINE'),
                SOC: item.SOC ?? 'N/A',
                BATT: item.type_batt ?? 'N/A',
                PCKS: item.nb_packs ?? 'N/A',
                MAX_LEVEL: item['MAX(URGENCY_LEVEL)'] ?? 'N/A',

            }));
            setData(results);
            setFilteredData(results);
        }     
        
        // Fonction de nettoyage pour vider les données
        return () => {
            setData([]); // Réinitialise les données à un tableau vide quand le composant est démonté
            setFilteredData([]);
        };
    }, [fleet]);

    // Fonction pour mettre à jour les données filtrées
    const handleFilteredData = (newFilteredData) => {
        if (JSON.stringify(newFilteredData) !== JSON.stringify(filteredData)) {
            setFilteredData(newFilteredData);
        }
    };

    const headers = [     
        { label: 'Parc', key: 'PARK_NUMBER', type: 'string', canToggle: false, visible: true },
        { label: 'Vin', key: 'VIN', type: 'string', canToggle: false, visible: true },
        { label: "Etat", key: 'STATE', type: 'string',  canToggle: false, visible: true },
        { label: "", key: '', type: 'action', icon: 'STATE', action: handleViewBus, canToggle: false, visible: true }, 
        { label: "Statut", key: '', type: 'action', icon: 'MAX', action: handleViewBus, canToggle: false, visible: true },    
        { label: "Batterie", key: 'BATT', type: 'string',  canToggle: false, visible: true },
        { label: "Packs", key: 'PCKS', type: 'string',  canToggle: false, visible: true },   
        { label: 'Charge', key: 'SOC', type: 'string', icon: 'batteryIndicator', canToggle: false, visible: true },
        { label: '', key: 'bus_info', type: 'action', action: handleViewBus, icon: 'viewBus', canToggle: false, visible: true, title: 'Voir le détail du bus'},
    ]     
    
    return (
        <>
            {data && (
                <div className="custom-table-container">
                    <div className={'flex justify-between items-end'}>
                        <div className="flex flex-col"></div>
                        <div className='flex'>
                            <SearchInput data={data} onFilteredData={handleFilteredData} />
                        </div>
                    </div>  
                    <div className='my-4'>                   
                        <CustomTable data={filteredData} headers={headers} maxHeight={`${height-52}px`}/>                    
                    </div>
                </div>
            )}
        </>
    )    
}